<template>
    <btn :type="type" :size="size" :disabled="loading" @click="$emit('click')">
        <div class="text-wrapper">
            <!-- We are using the css 'visibility' to keep the width of the button regardless of the text content -->
            <div :style="{ visibility: loading ? 'hidden' : 'visible' }">
                <i v-if="icon" :class="`fa fa-${icon}`" aria-hidden="true" />
                {{ text }}
            </div>
            <div class="spinner-wrapper">
                <i v-if="loading" class="fa fa-spinner fa-spin text-center" aria-hidden="true" />
            </div>
        </div>
    </btn>
</template>

<script>

import { Btn } from 'uiv';

export default {
    name: "SubmitButton",
    components: {
        Btn,
    },
    props: {
        // The text to be presented in the button.
        text: {
            type: String,
            required: true,
        },
        // Optional fontawesome icon to be displayed in the button.
        icon: {
            type: String,
            required: false,
            default: '',
        },
        // Type of the Bootstrap button. Options are:
        // 'default', 'primary', 'info', 'success', 'warning', 'danger', 'link'
        type: {
            type: String,
            default: '',
            validator: function (value) {
                // The type prop value must be exactly one of these strings
                // Please visit https://uiv.wxsm.space/components/btn.html for more information.
                return ['default', 'primary', 'info', 'success', 'warning', 'danger', 'link'].indexOf(value) !== -1
            },
        },
        // Size of the Bootstrap button. Otions are:
        // 'lg', 'sm', 'xs'
        size: {
            type: String,
            default: '',
            validator: function (value) {
                // The size prop value must be exactly one of these strings
                // Please visit https://uiv.wxsm.space/components/btn.html#sizes for more information.
                return ['', 'lg', 'sm', 'xs'].indexOf(value) !== -1
            },
        },
        // Display the loading spinner, otherwise, display the button text.
        loading: {
            type: Boolean,
            default: false,
        },
    },
}
</script>

<style scoped>
.text-wrapper {
    position: relative;
    margin: 0 auto;
    text-align: center;
}
.spinner-wrapper {
    position: absolute;
    top: 0;
    width: 100%;
}
</style>
